import React from 'react';
import Breadcrumbs from './Breadcrumbs';
import './PageHeader.css';

/**
 * Consistent page header: breadcrumbs on top, title + optional description,
 * actions row on the right. Every practice-view page should render this
 * as the first child under its route.
 *
 * <PageHeader
 *   title="Waitlist"
 *   description="Auto-offer cancelled slots to waitlisted patients."
 *   actions={<button>Add entry</button>}
 * />
 */
function PageHeader({ title, description, actions, showBreadcrumbs = true }) {
  return (
    <div className="page-header">
      {showBreadcrumbs && <Breadcrumbs />}
      <div className="page-header__row">
        <div>
          {title && <h1 className="page-header__title">{title}</h1>}
          {description && <p className="page-header__description">{description}</p>}
        </div>
        {actions && <div className="page-header__actions">{actions}</div>}
      </div>
    </div>
  );
}

export default PageHeader;
